<script lang="ts">
  export let stationName: string = '';
  export let metadataText: string = '';
  export let stationCount: number = 10;
  export let currentIndex: number = 1;
  export let scrolling: boolean = false;
  export let scrollDuration: string = '0s';
</script>

<div id="dot-matrix-panel">
  <div id="dm-zone-name">{stationName}</div>
  <div id="dm-zone-meta-wrapper">
    <div
      id="dm-zone-meta"
      class:no-info={!metadataText}
      class:scrolling={scrolling}
      data-text={scrolling ? metadataText : undefined}
      style={scrolling ? `--marquee-duration: ${scrollDuration}` : ''}
    >
      {metadataText || ''}
    </div>
  </div>
  <div id="dm-zone-indicator">
    {#each Array.from({ length: stationCount }, (_, i) => i + 1) as slot}
      <div class="dm-indicator-slot">
        <div class="dm-indicator-rect" class:rect-active={slot === currentIndex}></div>
        <span class="dm-indicator-label">{slot}</span>
      </div>
    {/each}
  </div>
</div>
